"use strict";

exports.__esModule = true;
exports.createRef = createRef;
/**
 * This is similar to React.createRef(),
 * the current version of this library doesn't support it.
 * @returns {function} the ref func
 */
function createRef() {
  var f = function f(element) {
    f.current = element;
  };
  return f;
}



//////////////////
// WEBPACK FOOTER
// ./~/auth0-lock/lib/utils/createRef.js
// module id = 1214
// module chunks = 0